import { render, staticRenderFns } from "./WebixStudyLog.vue?vue&type=template&id=eef4bdee&scoped=true&"
import script from "./WebixStudyLog.vue?vue&type=script&lang=js&"
export * from "./WebixStudyLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef4bdee",
  null
  
)

export default component.exports